$(document).ready(function(){
  // Obtém a URL atual
const url = new URL(window.location.href);

// Obtém os parâmetros de consulta
const params = new URLSearchParams(url.search);

// Obtém o valor do parâmetro 'result'
const result = params.get('result');
  
  $("#cat_"+result).removeClass("cat_oculto");
  $("#prods_"+result).removeClass("prods_oculto");
});